import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PUBLIC_PATHS } from '../../config/navConfig';
import PublicHeader from './PublicHeader';
import AppShell from './AppShell';

const RootLayout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  // Every page change starts at the top instead of keeping the previous page's scroll offset.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const isPublic = PUBLIC_PATHS.includes(location.pathname);

  return isPublic ? <PublicHeader>{children}</PublicHeader> : <AppShell>{children}</AppShell>;
};

export default RootLayout;
